module.exports = __webpack_public_path__ + "img/referral.5eb88934.svg";